/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DxTrialsControllerSignupMutationRequest, DxTrialsControllerSignupMutationResponse } from "../../models/dxTrialsController/DxTrialsControllerSignup";

function getDxTrialsControllerSignupUrl() {
  const res = { method: 'POST', url: `/api/v1/dx-trials/signup` as const }  
  return res
}

/**
 * @summary Subscribe and provision a TID trial signup
 * {@link /api/v1/dx-trials/signup}
 */
export async function dxTrialsControllerSignup(data?: DxTrialsControllerSignupMutationRequest, config: Partial<RequestConfig<DxTrialsControllerSignupMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DxTrialsControllerSignupMutationResponse, ResponseErrorConfig<Error>, DxTrialsControllerSignupMutationRequest>({ method : "POST", url : getDxTrialsControllerSignupUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}